import React from 'react';

import { LayoutContainer } from '@zooplus/ui-components';

import SearchBar from './SearchBar';
import styles from './SearchBar.module.scss';

const MobileSearchBar = (): React.JSX.Element => {
    return (
        <div
            className={styles.searchBarMobile}
            data-zta="header-search-bar-mobile"
            id="mobileSearchBar">
            <LayoutContainer variant="default">
                <SearchBar device="mobile" />
            </LayoutContainer>
        </div>
    );
};

export default MobileSearchBar;
